/** 表格拖拽绘制：默认行列与最小有效选区（画布像素） */
export const DEFAULT_TABLE_DRAW_ROWS = 5;
export const DEFAULT_TABLE_DRAW_COLS = 4;
export const MIN_TABLE_DRAW_SIZE = 20;

export function distributeTableSizes(total: number, count: number): number[] {
  const n = Math.max(1, count);
  const each = total / n;
  return Array.from({ length: n }, () => each);
}
